// Must export moment to window namespace for moment-duraton-format to work
window.moment = require("moment");
require("moment-duration-format");
